module.exports = __webpack_public_path__ + "img/1520560670.33a6332c.jpg";